import { useCallback, useState } from 'react';

export function useOpenCloseState(startState: boolean) {
	const [open, setOpen] = useState(startState);
	const openCallback = useCallback(() => setOpen(true), []);
	const closeCallback = useCallback(() => setOpen(false), []);

	return [open, openCallback, closeCallback] as const;
}
